const isId = (value) => {
	console.log(value);
	const regExp = /^[a-z]+[a-z0-9]{5,19}$/g;

	return regExp.test(value);
}

export {
	isId
}